import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { useTranslation } from "react-i18next";
import axiosInstance from "../../axiosInstance";
import moment from "moment";
import { useAuth } from "../../AuthContext";
import { useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";

const OrgnizerEventManagementTabs = () => {
  const [activeTab, setActiveTab] = useState("speakers");
  const { t, i18n } = useTranslation();
  const languageDirection = i18n.language === "ar" ? "rtl" : "ltr";
  const navigate = useNavigate();
  const [events, setEvents] = useState([]);
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(10);
  const { userId } = useAuth();
  toast.dismiss();
  const { eventId } = useParams();
  const [eventDetail, setEventDetail] = useState(null);
  const [eventInvitations, setEventInvitations] = useState([]);
  const [pendingInvites, setPendingInvites] = useState([]);
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [approvedSpeakers, setApprovedSpeakers] = useState([]);
  const [approvedInvites, setApprovedInvites] = useState([]);
  const [rejectedInvites, setRejectedInvites] = useState([]);
  const [approvedRequests, setApprovedRequests] = useState([]);
  const [rejectedRequests, setRejectedRequests] = useState([]);
  const pastInvites = [...approvedInvites, ...rejectedInvites];
  const [allInvites, setAllInvites] = useState([]);

  const [pendingRequests, setPendingRequests] = useState([]);

  const statusBadge = {
    pending: <span className="badge bg-warning text-dark">معلقة</span>,
    accepted: <span className="badge bg-success">مقبولة</span>,
    declined: <span className="badge bg-secondary">مرفوضة</span>,
  };

  const fetchApprovedSpeakers = async () => {
    try {
      const response = await axiosInstance.get(
        `/api/v1/organizers/events/${eventId}/invitations?filter=3`
      );
      const data = response.data || [];

      console.log("All Invitations:", data);

      setApprovedSpeakers(data[0]?.approved || []);
    } catch (error) {
      console.error("Error fetching approved speakers:", error);
    }
  };

  const fetchInvitations = async () => {
  try {
    const response = await axiosInstance.get(
      `/api/v1/organizers/events/${eventId}/invitations?filter=1`
    );

    const { approved = [], pending = [], rejected = [] } = response.data;

    setAllInvites([...approved, ...pending, ...rejected]); 
    setPendingInvites(pending);
    setApprovedInvites(approved);
    setRejectedInvites(rejected);
  } catch (error) {
    console.error("Error fetching invitations:", error);
  }
};


  const fetchSpeakerRequests = async () => {
  try {
    const response = await axiosInstance.get(
      `/api/v1/organizers/events/${eventId}/invitations?filter=2`
    );

    const { approved = [], pending = [], rejected = [] } = response.data;

    setPendingRequests(pending);
    setApprovedRequests(approved);
    setRejectedRequests(rejected);
  } catch (error) {
    console.error("Error fetching speaker requests:", error);
    setError("فشل في جلب الطلبات");
  }
};


  const respondToRequest = async (invitationId, status) => {
    try {
      await axiosInstance.post(
        `/api/v1/organizers/events/${eventId}/requests/${invitationId}/response`,
        {
          Body:
            status === 3 ? "Accepted by organizer" : "Rejected by organizer",
          Status: status,
        }
      );
      toast.success(status === 3 ? "تم القبول" : "تم الرفض");
      fetchSpeakerRequests(); // إعادة تحميل الطلبات
    } catch (error) {
      toast.error("فشل الإجراء");
    }
  };

  // زر الإلغاء
  const cancelInvitation = async (invitationId) => {
    try {
      await axiosInstance.post(
        `/api/v1/organizers/events/${eventId}/invitations/${invitationId}/cancel`
      );
      toast.success("تم إلغاء الدعوة");
      // إعادة تحميل الدعوات بعد الإلغاء
      fetchInvitations();
    } catch (error) {
      toast.error("فشل إلغاء الدعوة");
    }
  };

  useEffect(() => {
    if (eventId) fetchInvitations();
  }, [eventId]);

  useEffect(() => {
    const fetchMyEvents = async () => {
      try {
        const response = await axiosInstance.get(`/api/v1/organizers/events`, {
          params: {
            Page: page,
            PageCount: pageCount,
          },
        });
        const events = response.data.items;
        setEvents(events);
      } catch (error) {
        console.error("Error fetching events:", error);
      }
    };

    fetchMyEvents();
  }, [page, pageCount]);

  useEffect(() => {
    const fetchEventDetail = async () => {
      try {
        const response = await axiosInstance.get(
          `/api/v1/organizers/events/${eventId}`
        );
        setEventDetail(response.data);
      } catch (error) {
        console.error("Error fetching event detail:", error);
        setError("فشل في جلب تفاصيل الحدث");
      } finally {
        setLoading(false);
      }
    };

    if (eventId) {
      fetchEventDetail();
    }
  }, [eventId]);

  useEffect(() => {
    fetchInvitations();
    fetchSpeakerRequests();
  }, [eventId]);

  useEffect(() => {
    if (eventId) fetchSpeakerRequests();
  }, [eventId]);

  useEffect(() => {
    if (eventId) fetchApprovedSpeakers();
  }, [eventId]);

  return (
    <div className="card shadow-sm mb-5">
      <div className="card-header bg-white">
        <ul className="nav nav-tabs card-header-tabs">
          <li className="nav-item">
            <button
              className={`nav-link ${activeTab === "speakers" ? "active" : ""}`}
              onClick={() => setActiveTab("speakers")}
            >
              <i className="fas fa-users me-2"></i> {t("tabs.speakers")}
              <span className="badge bg-success ms-1">
                {approvedInvites.length}
              </span>
            </button>
          </li>

          <li className="nav-item">
            <button
              className={`nav-link ${
                activeTab === "invitations" ? "active" : ""
              }`}
              onClick={() => setActiveTab("invitations")}
            >
              <i className="fas fa-paper-plane me-2"></i>{" "}
              {t("tabs.invitations")}
              <span className="badge bg-warning text-dark ms-1">
                {pendingInvites.length}
              </span>
            </button>
          </li>

          <li className="nav-item">
            <button
              className={`nav-link ${activeTab === "requests" ? "active" : ""}`}
              onClick={() => setActiveTab("requests")}
            >
              <i className="fas fa-envelope me-2"></i> {t("tabs.requests")}
              <span className="badge bg-info ms-1">
                {pendingRequests.length}
              </span>
            </button>
          </li>
        </ul>
      </div>

      <div className="card-body">
        {/* Speakers Tab */}
        {activeTab === "speakers" && (
          <div>
            <h5 className="mb-4">{t("confirmedSpeakers")}</h5>
            {approvedSpeakers.length > 0 ? (
              <div className="row">
                {approvedSpeakers.map((invitation, index) => (
                  <div className="col-md-6 col-lg-4 mb-4" key={index}>
                    <div className="card hover-card h-100 shadow-sm">
                      <div className="card-body">
                        <div className="d-flex align-items-center mb-3">
                          <div className="speaker-avatar me-3">
                            <img
                              src={invitation.speaker?.profileImage}
                              alt={t("speakerImageAlt")}
                              className="rounded-circle"
                              width="60"
                              height="60"
                            />
                          </div>
                          <div>
                            <h5 className="card-title mb-1">
                              {invitation.speaker?.arabicFullName ||
                                t("defaultSpeakerName")}
                            </h5>
                            <p className="card-subtitle text-muted mb-0">
                              {invitation.speaker?.arabicJobTitle ||
                                t("defaultSpeakerTitle")}
                            </p>
                          </div>
                        </div>
                        <div className="mb-3">
                          <span className="badge bg-primary-custom mb-2">
                            {invitation.role || t("defaultRole")}
                          </span>
                          <p className="card-text">
                            {invitation.invitationMessage || t("defaultTopic")}
                          </p>
                        </div>
                        <div className="mb-2 d-flex align-items-center">
                          <i className="fas fa-money-bill text-success me-2"></i>
                          <span className="fw-semibold">
                            {invitation.price || "0"} {t("currency")}
                          </span>
                          <span className="badge bg-light text-dark ms-2">
                            {t("participationPrice")}
                          </span>
                        </div>
                        <div className="d-flex justify-content-end">
                          <button className="btn btn-sm btn-outline-secondary">
                            <i className="fas fa-comment me-1"></i>{" "}
                            {t("message")}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <p>{t("noSpeakers")}</p>
            )}
          </div>
        )}

        {/* Invitations Tab */}
        {activeTab === "invitations" && (
          <div className="tab-pane fade show active" id="invitations">
            {/* الدعوات المعلقة */}
            <div className="mb-4">
              <h5 className="mb-0">
                {t("pendingInvitations")} ({pendingInvites.length})
              </h5>
            </div>
            <div className="table-responsive">
              {pendingInvites.length === 0 ? (
                <div className="text-center text-muted py-4">
                  {t("noPendingInvitations")}
                </div>
              ) : (
                <table className="table table-hover border">
                  <thead className="table-light">
                    <tr>
                      <th>{t("speaker")}</th>
                      <th>{t("role")}</th>
                      <th>{t("invitationDate")}</th>
                      <th>{t("status")}</th>
                      <th>{t("actions")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {pendingInvites.map((invite) => (
                      <tr key={invite.id}>
                        <td>{invite?.speaker?.userName || "-"}</td>
                        <td>{invite?.speakerRoleName || "-"}</td>
                        <td>
                          {new Date(invite?.createdOn).toLocaleDateString()}
                        </td>
                        <td>{invite?.statusName || "-"}</td>

                        <td>
                          <button className="btn btn-sm btn-primary">
                            {t("accept")}
                          </button>{" "}
                          <button className="btn btn-sm btn-danger">
                            {t("decline")}
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>

            {/* الدعوات المقبولة */}
            <div className="mb-4 mt-5">
              <h5 className="mb-0">
                {t("approvedInvitations")} ({approvedInvites.length})
              </h5>
            </div>
            <div className="table-responsive">
              {approvedInvites.length === 0 ? (
                <div className="text-center text-muted py-4">
                  {t("noApprovedInvitations")}
                </div>
              ) : (
                <table className="table table-hover border">
                  <thead className="table-light">
                    <tr>
                      <th>{t("speaker")}</th>
                      <th>{t("role")}</th>
                      <th>{t("invitationDate")}</th>
                      <th>{t("status")}</th>
                      <th>{t("actions")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {approvedInvites.map((invite) => (
                      <tr key={invite.id}>
                        <td>{invite?.speaker?.userName || "-"}</td>
                        <td>{invite?.speakerRoleName || "-"}</td>
                        <td>
                          {new Date(invite?.createdOn).toLocaleDateString()}
                        </td>
                        <td>{invite?.statusName || "-"}</td>

                        <td>
                          <button className="btn btn-sm btn-info">
                            {t("chat")}
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>

            {/* الدعوات المرفوضة */}
            <div className="mb-4 mt-5">
              <h5 className="mb-0">
                {t("rejectedInvitations")} ({rejectedInvites.length})
              </h5>
            </div>
            <div className="table-responsive">
              {rejectedInvites.length === 0 ? (
                <div className="text-center text-muted py-4">
                  {t("noRejectedInvitations")}
                </div>
              ) : (
                <table className="table table-hover border">
                  <thead className="table-light">
                    <tr>
                      <th>{t("speaker")}</th>
                      <th>{t("role")}</th>
                      <th>{t("invitationDate")}</th>
                      <th>{t("status")}</th>
                      <th>{t("actions")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rejectedInvites.map((invite) => (
                      <tr key={invite.id}>
                        <td>{invite.speakerName}</td>
                        <td>{invite.role}</td>
                        <td>{invite.invitationDate}</td>
                        <td>{invite.status}</td>
                        <td>
                          <button className="btn btn-sm btn-info">
                            {t("chat")}
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        )}

        {/* Requests Tab */}
        {activeTab === "requests" && (
          <div className="container py-4">
            {/* الطلبات المعلقة */}
            <h5 className="mb-4">{t("Requests.pendingTitle")}</h5>
            {pendingRequests.length === 0 ? (
              <div className="text-center text-muted py-4">
                {t("noPendingData")}
              </div>
            ) : (
              <div className="row">
                {pendingRequests.map((req) => (
                  <div className="col-md-6 mb-4" key={req.id}>
                    <div className="card shadow-sm">
                      <div className="card-body">
                        <h5 className="card-title">{req.userName}</h5>
                        <p className="card-text">
                          {t("Requests.role")}: {req.role}
                        </p>
                        <p className="card-text">
                          {t("Requests.type")}: {req.type}
                        </p>
                        <p className="card-text">
                          {t("Requests.agency")}: {req.agency}
                        </p>
                        <p className="card-text">
                          {t("Requests.date")}: {req.date}
                        </p>
                        <div className="d-flex gap-2 mt-3">
                          <button
                            className="btn btn-sm btn-success"
                            onClick={() => respondToRequest(req.id, 3)} // قبول
                          >
                            {t("accept")}
                          </button>
                          <button
                            className="btn btn-sm btn-danger"
                            onClick={() => respondToRequest(req.id, 4)} // رفض
                          >
                            {t("decline")}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}

            <hr className="my-5" />

            {/* الطلبات المقبولة */}
            <h5 className="mb-4">{t("Requests.approvedTitle")}</h5>
            {approvedRequests.length === 0 ? (
              <div className="text-center text-muted py-4">
                {t("noApprovedData")}
              </div>
            ) : (
              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>{t("Requests.user")}</th>
                      <th>{t("Requests.role")}</th>
                      <th>{t("Requests.type")}</th>
                      <th>{t("Requests.agency")}</th>
                      <th>{t("Requests.date")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {approvedRequests.map((req) => (
                      <tr key={req.id}>
                        <td>{req.userName}</td>
                        <td>{req.role}</td>
                        <td>{req.type}</td>
                        <td>{req.agency}</td>
                        <td>{req.date}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}

            <hr className="my-5" />

            {/* الطلبات المرفوضة */}
            <h5 className="mb-4">{t("Requests.rejectedTitle")}</h5>
            {rejectedRequests.length === 0 ? (
              <div className="text-center text-muted py-4">
                {t("noRejectedData")}
              </div>
            ) : (
              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>{t("Requests.user")}</th>
                      <th>{t("Requests.role")}</th>
                      <th>{t("Requests.type")}</th>
                      <th>{t("Requests.agency")}</th>
                      <th>{t("Requests.date")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rejectedRequests.map((req) => (
                      <tr key={req.id}>
                        <td>{req.userName}</td>
                        <td>{req.role}</td>
                        <td>{req.type}</td>
                        <td>{req.agency}</td>
                        <td>{req.date}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default OrgnizerEventManagementTabs;
